/**
 * @generated SignedSource<<32ba0e84cb4199e3ca5e34cfacda4f19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tabs_businessHorizontalNav_TabsContent$data = {
  readonly navigationItems: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "JiraNavigationItemEdge";
    } | null | undefined> | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabListOld_TabList">;
  };
  readonly " $fragmentType": "tabs_businessHorizontalNav_TabsContent";
};
export type tabs_businessHorizontalNav_TabsContent$key = {
  readonly " $data"?: tabs_businessHorizontalNav_TabsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"tabs_businessHorizontalNav_TabsContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "projectIdOrKey"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": [
          "navigationItems"
        ]
      }
    ]
  },
  "name": "tabs_businessHorizontalNav_TabsContent",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "navigationItems",
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
          }
        ],
        "concreteType": "JiraNavigationItemConnection",
        "kind": "LinkedField",
        "name": "__tabs_jiraNavigation__navigationItems_connection",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ui_navigationKitTabListOld_TabList"
          },
          {
            "concreteType": "JiraNavigationItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "cursor"
              },
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              },
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "navigationItems"
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "c292b845078d48f1c79863de64495f87";

export default node;
